// EmptyState: nothing to show, said plainly in a dashed box: a title, a muted line, an action.
// size sm is the quiet one-liner (an empty board column).
import type { ReactNode } from 'react';
import { cn } from './cn';

export function EmptyState({
  title,
  children,
  action,
  size = 'md',
  className,
}: {
  title?: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  size?: 'sm' | 'md';
  className?: string;
}) {
  return (
    <div
      className={cn(
        'grid justify-items-center gap-1 rounded-lg border border-dashed text-center',
        size === 'sm' ? 'border-hairline p-3.5 text-[12px] text-ink-muted' : 'border-hairline-strong px-5 py-7',
        className,
      )}
    >
      {title && <b className="font-medium text-ink-display [overflow-wrap:anywhere]">{title}</b>}
      {children && <span className="text-ink-muted">{children}</span>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
